import React, { FC, useState, useContext, useEffect } from 'react'
import styled, { css } from 'styled-components'
import { Link, NavLink, Switch, Route } from 'react-router-dom'
import { StyleNavigationLogoIcon } from '../styles'
import { GREEN, BLACK, easeInCss, easeOutCss, GRAY_5 } from '../../contants'
import BackIcon from '../../../icons/back.svg'
import { StuffContext } from '../../context/stuff'
import getUndef from '../../../utils/get-undef'
import dotsIcon from '../../../icons/dots.svg'
import { useHistory } from 'react-router'
import { ReviewNotificationContext } from '../../context/review-notification'
import CustomSelect from '../../form/custom-select'
// import NextIcon from '../../../icons/next.svg'

interface IItem {
  text: string
  href?: string
  before?: boolean
  newReviews?: any
}

interface ILevel {
  items: Array<IItem>
  path: string
  exact?: boolean
}

interface IBurgerMenu {
  isOpen: boolean
  onClick: (e: any) => void
}

interface INavigationWrapper {
  isOpen: boolean
}

interface ISeparator {
  isOpen: boolean
}

const Navigation: FC<{}> = () => {
  const [stuffOptionsIsOpen, setStuffOptionsIsOpen] = useState(false)
  const { isAdmin, stuff } = useContext(StuffContext)
  const shopName = getUndef(() => stuff.shops[0].name)
  const history = useHistory()
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  const [isOpen, setIsOpen] = useState(false)
  const reviewsContext = useContext(ReviewNotificationContext)
  const newReviews = reviewsContext[0]

  useEffect(() => {
    const updateSize = () => setScreenWidth(window.innerWidth)
    updateSize()

    window.addEventListener('resize', updateSize)
    return () => window.removeEventListener('resize', updateSize)
  }, [screenWidth])

  const switchView = screenWidth > 1280
  const handleClick = e => {
    e.preventDefault()
    setIsOpen(!isOpen)
  }

  function logout() {
    try {
      localStorage.removeItem('stuff')
      history.push('/')
    } catch (error) {
      console.error(error)
    }
  }

  const rootItems: Array<IItem> = [
    { text: 'Заказы', href: '/shop/orders' },
    { text: 'Клиенты', href: '/shop/customers' }
  ]

  if (isAdmin) {
    rootItems.unshift({ text: 'Статистика', href: '/shop/analytics' })
    rootItems.push(
      ...[
        { text: 'Акции', href: '/shop/discounts' },
        { text: 'Управление' },
        { text: 'Товары', href: '/shop/items' },
        { text: 'Категории', href: '/shop/collections' },
        { text: 'Магазины', href: '/shops' },
        { text: 'Сотрудники', href: '/shop/stuff' },
        { text: 'Страницы', href: '/shop/pages/pages', newReviews },
        { text: 'Настройки', href: '/shop/settings' },
        { text: 'iiko', href: '/shop/iiko' }
      ]
    )
  }

  const routes: Array<ILevel> = [
    // Pages
    {
      path: '/shop/pages',
      items: [
        { text: 'Вернуться', before: true, href: '/shop/orders' },
        { text: 'Акции', href: '/shop/pages/promo' },
        { text: 'Отзывы', href: '/shop/pages/reviews', newReviews },
        { text: 'Страницы', href: '/shop/pages/pages' },
        { text: 'Навигация' },
        { text: 'Меню', href: '/shop/pages/navigation/catalog-menu' },
        { text: 'Шапка', href: '/shop/pages/navigation/123' },
        { text: 'Низ сайта', href: '/shop/pages/navigation/footer-menu' }
      ]
    },
    // Root
    {
      path: '/',
      items: rootItems
    }
  ]

  return (
    <NavigationWrapper isOpen={isOpen}>
      <Logo to="/shop/orders">
        <LogoIcon>
          {(process.env.REACT_APP_PROJECT_LOGO && (
            <StyleNavigationLogoIcon />
          )) ||
            ''}
        </LogoIcon>
        {(switchView || isOpen) && (
          <span>{`${process.env.REACT_APP_PROJECT_NAME}`}</span>
        )}
      </Logo>
      <Separator isOpen={isOpen} />
      {!switchView && (
        <BurgerMenu isOpen={isOpen} onClick={handleClick}>
          <input id="menu__toggle" type="checkbox" />
          <label className="menu__btn" htmlFor="menu__toggle">
            <span></span>
          </label>
        </BurgerMenu>
      )}
      {(switchView || isOpen) && (
        <>
          <ul>
            <Switch>
              {routes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  exact={route.exact}
                  children={data => {
                    const routeData = routes[index]
                    return routeData.items.map(itemProps => (
                      <NavItem key={itemProps.text} {...itemProps} />
                    ))
                  }}
                />
              ))}
            </Switch>
          </ul>
          <hr />

          <CurrentStuff>
            <div className="info">
              <h4>{stuff ? stuff.login : ''}</h4>
              <p>{isAdmin ? 'Администратор' : 'Оператор'}</p>
            </div>
            <StuffBtn
              onClick={() => setStuffOptionsIsOpen(prev => !prev)}
            ></StuffBtn>

            <StuffOptions
              isOpen={stuffOptionsIsOpen}
              onClick={() => setStuffOptionsIsOpen(false)}
            >
              <li onClick={logout}>Выйти</li>
            </StuffOptions>
          </CurrentStuff>
        </>
      )}
    </NavigationWrapper>
  )
}

const headerPseudo = css`
  & {
    display: inline-block;
    height: 10px;
    width: 6px;
    background: url(${BackIcon}) no-repeat center;
    background-size: contain;
    margin-right: 0.5em;
    content: '';
  }
`

const headerStyles = css`
  && {
    font-size: 12px;
    text-transform: uppercase;
    line-height: 1;
    font-weight: bold;
    color: ${GRAY_5} !important;
  }
`

const NavItem: FC<IItem> = ({ text, before, href, newReviews }) => {
  return (
    <li>
      {href ? (
        <NavItemLink
          className={!!before ? 'before' : ''}
          to={href}
          activeClassName="active"
        >
          {text}{' '}
          {newReviews > 0 && <NewReviewsIcon>{newReviews}</NewReviewsIcon>}
        </NavItemLink>
      ) : (
        <Header>{text}</Header>
      )}
    </li>
  )
}

const NewReviewsIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  font-weight: bold;
  font-size: 12px;

  margin-top: 4px;
  margin-left: 4px;
  padding-bottom: 2px;

  width: 18px;
  height: 18px;
  border-radius: 50%;

  background: #e32d2d;
  color: #ffffff;
`

const NavigationWrapper = styled.div<INavigationWrapper>`
  z-index: 10000;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  width: 190px;
  padding: 30px;
  overflow-y: auto;
  overflow-x: hidden;
  background: #f5f9fc;
  transition: width 0.125s ease-out;

  @media (max-width: 1280px) {
    ${p => (p.isOpen ? '' : 'align-items: center')};
    width: ${p => (p.isOpen ? '240px' : '100px')};
    padding: ${p => (p.isOpen ? '30px' : '30px 10px')};
  }

  &:after {
    z-index: -1;
    position: absolute;
    left: 100%;
    top: 0;
    bottom: 0;
    display: block;
    height: 100%;
    width: 100px;

    pointer-events: none;
    box-shadow: 0px 2px 44px rgba(73, 113, 143, 0.132784);
    content: '';
  }

  & > ul {
    flex-grow: 1;
    list-style: none;
    padding: 0;
    margin: 0 0 auto;
  }
`

const Separator = styled.hr<ISeparator>`
  @media (max-width: 1280px) {
    ${p => (p.isOpen ? '' : 'position: fixed')}
    ${p => (p.isOpen ? '' : 'top: 75px')}
    ${p => (p.isOpen ? '' : 'width: 26px')};
  }
`

const BurgerMenu = styled.div<IBurgerMenu>`
  & > input {
    opacity: 0;
  }
  .menu__btn {
    display: flex;
    align-items: center;
    position: fixed;
    top: ${p => (p.isOpen ? '27px' : '125px')};
    left: ${p => (p.isOpen ? '200px' : '36.5px')};
    width: ${p => (p.isOpen ? '18px' : '26px')};
    height: 26px;
    cursor: pointer;
    z-index: 1;
    ${p => (p.isOpen ? 'animation: fade-in 0.5s ease-out' : '')};
  }

  .menu__btn > span,
  .menu__btn > span::before,
  .menu__btn > span::after {
    display: block;
    position: absolute;
    width: 100%;
    height: 2px;
    background-color: #616161;
    transition: all 0.125s ease-out;
  }

  .menu__btn > span {
    transform: ${p => (p.isOpen ? 'rotate(45deg)' : 'rotate(0)')};
  }

  .menu__btn > span::before {
    content: '';
    top: ${p => (p.isOpen ? '0' : '-8px')};
    transform: rotate(0);
  }
  .menu__btn > span::after {
    content: '';
    top: ${p => (p.isOpen ? '0' : '8px')};
    transform: ${p => (p.isOpen ? 'rotate(90deg)' : 'rotate(0)')};
  }

  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`

const NavItemLink = styled(NavLink)`
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 18px;
  line-height: 40px;
  color: ${BLACK};
  outline: none;
  font-weight: bold;
  ${easeInCss};

  &.active,
  &:hover {
    text-decoration: none;
    color: ${GREEN};
    ${easeOutCss};
  }

  &:focus {
    outline: none;
  }

  &.before {
    ${headerStyles};
    && {
      margin-bottom: 10px;
    }
    &:before {
      ${headerPseudo};
    }
  }
`

const Header = styled.p`
  ${headerStyles};
  && {
    margin: 30px 0 10px;
  }
`

const Logo = styled(Link)`
  flex-shrink: 0;
  color: ${BLACK};
  &:hover {
    color: ${BLACK};
    text-decoration: none;
  }
  &:focus {
    outline: none;
  }
  span {
    display: block;
    font-size: 24px;
    line-height: 28px;
    font-weight: bold;
  }
`

const LogoIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  width: 50px;
  height: 50px;
  background: ${GREEN};
  border-radius: 15px;
`

const CurrentStuff = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;

  h4,
  p {
    margin: 0;
  }

  h4 {
    font-size: 14px;
    line-height: 16px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: ${BLACK};
  }

  p {
    margin-top: 0.25em;
    color: ${GRAY_5};
    font-size: 12px;
  }
`

const StuffBtn = styled.button`
  border: none;
  padding: 0;
  display: block;
  width: 20px;
  height: 20px;
  background: url(${dotsIcon}) no-repeat center;
  cursor: pointer;
`

interface IStuffOptions {
  isOpen: boolean
}
const StuffOptions = styled.ul<IStuffOptions>`
  position: absolute;
  right: 0;
  width: 100%;
  bottom: calc(100% + 10px);
  margin: 0;
  list-style: none;
  border-radius: 5px;
  background-color: #fff;
  padding: 10px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.025);
  ${({ isOpen }) => (isOpen ? easeOutCss : easeInCss)};
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  transform: ${({ isOpen }) => `translate3d(0,${isOpen ? '0' : '10px'},0)`};

  li {
    color: ${BLACK};
    font-weight: bold;
    cursor: pointer;

    ${easeInCss};
    &:hover {
      ${easeOutCss};
      color: ${GREEN};
    }
  }
`

const StyledSelect = styled(CustomSelect)`
  & > div > div {
    padding: 0;
  }
`

export default Navigation
